import { render } from "./Project.vue?vue&type=template&id=5a35d298&scoped=true"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"

import "./Project.vue?vue&type=style&index=0&id=5a35d298&lang=scss&scoped=true"

import exportComponent from "E:\\Work\\Elkashef\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a35d298"]])

export default __exports__